// Sentry 초기화 — load 이후로 지연해 엔트리 청크에서 sentry를 분리 (gzip -37KB)
// 트레이드오프: load 전에 터지는 에러는 캡처되지 않는다 (Post X 측정에서 결정)
const loadSentry = () => {
  void import("./sentry");
};
if (document.readyState === "complete") {
  loadSentry();
} else {
  window.addEventListener("load", loadSentry, { once: true });
}
import "./global.css";
import React from "react";
import ReactDom from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import {
  defaultShouldDehydrateQuery,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

import axios from "axios";
import { router } from "./common/router";
import { Toaster } from "./components/ui/sonner";

interface ApiError extends Error {
  response?: {
    data: {
      detail: string;
    };
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: true,
      staleTime: 60 * 1000,
      retry: (failureCount, error) => {
        if (axios.isAxiosError(error) && error.response?.status === 401) {
          return false;
        }
        return failureCount < 1;
      },
    },
    mutations: {
      throwOnError: false,
      onError(error: ApiError) {
        console.log("🚀 ~ onError:", error);
      },
      onSettled(data) {
        if (data) {
          void queryClient.invalidateQueries();
        }
      },
    },
    dehydrate: {
      shouldDehydrateQuery: (query) =>
        defaultShouldDehydrateQuery(query) || query.state.status === "pending",
    },
  },
});

const root = document.getElementById("root") ?? document.createElement("div");
ReactDom.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster expand />
    </QueryClientProvider>
  </React.StrictMode>,
);
